export default "__VITE_PUBLIC_ASSET__6ca8d9d4__"